(() => {
  const selectors = {
    alert: '[data-br-stock-alert]',
    data: '[data-br-stock-alert-data]',
    product: '[data-br-stock-product]',
    variant: '[data-br-stock-variant]',
    body: '[data-br-stock-body]'
  };

  const readData = (container) => {
    try {
      return JSON.parse(container.querySelector(selectors.data)?.textContent || '{}');
    } catch (error) {
      return {};
    }
  };

  const selectedVariantId = (container) => {
    const sectionId = container.dataset.sectionId;
    const productForm = document.getElementById('product-form-' + sectionId);
    const scopedInfo = container.closest('product-info');
    const input = productForm?.querySelector('input[name="id"]') || scopedInfo?.querySelector('input[name="id"]');
    return input?.value ? String(input.value) : '';
  };

  const sync = (container) => {
    const data = readData(container);
    const variantId = selectedVariantId(container);
    const variant = Array.isArray(data.variants)
      ? data.variants.find((item) => String(item.id) === variantId)
      : null;

    container.hidden = !variant || variant.available;
    if (!variant || variant.available) return;

    const productInput = container.querySelector(selectors.product);
    const variantInput = container.querySelector(selectors.variant);
    const bodyInput = container.querySelector(selectors.body);
    if (productInput) productInput.value = data.productTitle || '';
    if (variantInput) variantInput.value = variant.title || '';
    if (bodyInput) {
      bodyInput.value =
        'Készletértesítő kérés – ' +
        (data.productTitle || '') +
        ' – ' +
        (variant.title || '') +
        ' – ' +
        window.location.origin +
        (data.productUrl || window.location.pathname);
    }
  };

  const syncAll = () => {
    document.querySelectorAll(selectors.alert).forEach(sync);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  } else {
    syncAll();
  }

  document.addEventListener('change', () => window.setTimeout(syncAll, 40));
  document.addEventListener('input', () => window.setTimeout(syncAll, 40));
  document.addEventListener('shopify:section:load', syncAll);
  window.addEventListener('pageshow', syncAll);
})();
